import type { Task } from '../types/task'
import { taskApi } from './taskApi'

export type TaskNotificationIntent = {
  notifyAssignee: boolean
  notifyTeam: boolean
  scheduleReminder: boolean
}

const sortIds = (ids: string[] = []): string[] => Array.from(new Set(ids)).sort()

export const computeTaskNotificationIntent = (next: Task, previous?: Task): TaskNotificationIntent => {
  const notifyAssignee = Boolean(next.assigneeId) && (!previous || next.assigneeId !== previous.assigneeId)

  const nextCollaborators = sortIds(next.collaboratorIds)
  const previousCollaborators = sortIds(previous?.collaboratorIds ?? [])
  const collaboratorsChanged = nextCollaborators.length !== previousCollaborators.length ||
    nextCollaborators.some((id, index) => id !== previousCollaborators[index])
  const notifyTeam = nextCollaborators.length > 0 && (!previous || collaboratorsChanged)

  const reminderSettingsChanged = !previous ||
    previous.reminderSettings.enabled !== next.reminderSettings.enabled ||
    previous.reminderSettings.cadenceMinutes !== next.reminderSettings.cadenceMinutes

  const dueDateChanged = !previous || previous.dueAt !== next.dueAt

  const scheduleReminder = next.reminderSettings.enabled && (reminderSettingsChanged || dueDateChanged)

  return {
    notifyAssignee,
    notifyTeam,
    scheduleReminder
  }
}

export const deliverTaskNotificationPlaceholders = async (next: Task, previous?: Task): Promise<void> => {
  const intent = computeTaskNotificationIntent(next, previous)
  const deliveries: Promise<void>[] = []

  if (intent.notifyAssignee) {
    deliveries.push(taskApi.notifyAssignee(next))
  }

  if (intent.notifyTeam) {
    deliveries.push(taskApi.notifyTeam(next))
  }

  if (intent.scheduleReminder) {
    deliveries.push(taskApi.scheduleReminder(next))
  }

  if (deliveries.length === 0) {
    return
  }

  try {
    await Promise.all(deliveries)
  } catch (error) {
    console.warn('[task] notification placeholder failed', error)
  }
}
